module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/point03_sp-80225d3d3847c92c83560fffe1ad7892.png";